import CreateEarlyPromotion from './CreateEarlyPromotion.container';

export default CreateEarlyPromotion;
